interface DetailPageMaxImgProps {
  selectedImage: string;
  selectedVideo: string;
}

const DetailPageMaxImg = ({
  selectedImage,
  selectedVideo,
}: DetailPageMaxImgProps) => {
  return (
    <div className="display-max">
      <a href=".">
        <div
          className="max-img-pro"
          style={{ width: "400px", height: "500px" }}
        >
          {selectedVideo ? (
            <video
              src={selectedVideo}
              className="max-image-pro p-3"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              controls
              autoPlay
              loop
            />
          ) : (
            <img
              src={selectedImage}
              alt="img-blur-shadow"
              className="max-image-pro p-3"
              loading="lazy"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          )}
        </div>
      </a>
    </div>
  );
};

export default DetailPageMaxImg;
